document.addEventListener("DOMContentLoaded", main)

function main() {
    window.LocationsSection = LocationsSection()

    // check for serch params and open corresponding tab, if present
    const searchParams = new URLSearchParams(window.location.search);

    for (const param of searchParams) {
        if ( param[0] = 'location' ) {
            try {
                const locationName = param[1].replaceAll("_", "-");
                const tab = document.querySelector(`[data-info="${locationName}"]`);
                tab.click()
            } catch ( e ) {
                // unable to automatically open location tab, do nothing
            }
        }
    }

    try {
      if ( locationHandle != '' ) {
       const tab = document.querySelector(`[data-info="${locationHandle}"]`);
        tab.click();
      }
    } catch ( e ) {
      // not able to open
    }
    
}

function LocationsSection() {
    const SectionMethods = {
        init: function() {
            // console.log("init")
            const sections = document.querySelectorAll(".location-container")
            sections.forEach(section => {
                const sectionId = section.dataset.locationsId
                const selectedSection = `.location-container-${sectionId}`

                const querySelectedSection = document.querySelector(selectedSection)

                if ( querySelectedSection != null ) {
                    querySelectedSection.addEventListener("click", this.clickHandler)
                }
            })
        },

        clickHandler: function ( event ) {
            const aTag = event.target.closest(".nav-container a")

            if ( aTag ) {

                //Logic for removing underline and adding underline to active location
                const navContainer = aTag.closest(".nav-container")

                if ( navContainer ) {
                    const aTags = navContainer.querySelectorAll("a")

                    if ( aTags.length > 0 ) {
                        aTags.forEach(tag => {
                            tag.classList.remove("active")
                        })

                        aTag.classList.add("active")
                    }
                }

                //Logic for showing and now showing the correct container and information
                const linkIndex = aTag.dataset.index
                const infoContainers = document.querySelectorAll(".image-text-container")

                infoContainers.forEach(container => {
                    const containerIndex = container.dataset.index

                    if ( containerIndex == linkIndex ) {
                        container.classList.add("active")
                        let blockHandle = container.getAttribute('data-location');
                        let urlHandle = aTag.getAttribute('data-info');
                        let urlTitle = container.getAttribute('data-location-seo');

                        window.history.replaceState("", "", '/pages/showroom-locations/' + blockHandle);

                        // reinitialize slick slider
                        const mainSlider = container.querySelector('.image-slider');
                        const thumbnailSlider = container.querySelector('.thumbnail-images');

                        if ( mainSlider != null ) {
                            if ( mainSlider.classList.contains('slick-initialized')) {
                                $(mainSlider).slick("unslick")
                            }
                            SectionMethods.addSlick(`.image-slider-${blockHandle}`, `.thumbnail-image-slider-${blockHandle}`);
                        }

                        if ( thumbnailSlider != null ) {
                            if ( thumbnailSlider.classList.contains('slick-initialized')) {
                                $(thumbnailSlider).slick("unslick");
                            }

                            console.log(thumbnailSlider)
                            const nextArrow = container.querySelector(".slick-custom-button.next");
                            const prevArrow = container.querySelector('.slick-custom-button.previous');

                            // if ( nextArrow != null ) {
                            //     nextArrow.classList.remove('slick-arrow');
                            //     nextArrow.classList.remove('slick-hidden');
                            // }

                            // if ( prevArrow != null ) {
                            //     prevArrow.classList.remove('slick-arrow');
                            //     prevArrow.classList.remove('slick-hidden');
                            // }
                            console.log(nextArrow)
                            console.log(prevArrow)
                            SectionMethods.addSlickToChild(`.image-slider-${blockHandle}`, `.thumbnail-image-slider-${blockHandle}`, `.nextArrow-${blockHandle}`, `.prevArrow-${blockHandle}`)
                        }
                    } else {
                        container.classList.remove("active")

                        // remove slick from non active containers
                        const mainSlider = container.querySelector('.image-slider');
                        const thumbnailSlider = container.querySelector('.thumbnail-images');

                        if ( mainSlider != null ) {
                            if ( mainSlider.classList.contains('slick-initialized')) {
                                $(mainSlider).slick("unslick")
                            }
                        }

                        if ( thumbnailSlider != null ) {
                            if ( thumbnailSlider.classList.contains('slick-initialized')) {
                                $(thumbnailSlider).slick("unslick");
                            }
                        }

                    }
                })

                //Logic for syncing up teams with location
                const locationContainers = document.querySelectorAll(".location-container")
                const aTagText = aTag.dataset.info

                if ( locationContainers.length > 0 ) {
                    locationContainers.forEach(container => {
                        const locationLocation = container.dataset.location

                        if ( locationLocation == aTagText ) {
                            container.classList.add("active")
                        } else {
                            container.classList.remove("active")
                        }
                    })
                }

                //Logic for syncing hero images with location
                const heroContainers = document.querySelectorAll(".location-hero-container")

                for (let i = 0; heroContainers.length > i; i ++) {
                  const container = heroContainers[i]

                  if ( container ) {
                    const heroLocation = container.dataset.location

                    if ( heroLocation == aTagText ) {
                      container.classList.add("active")
                    } else {
                      container.classList.remove('active')
                    }
                  }
                }
            }
        },

        addSlick: function ( className, childClassName ) {
            $( className ).slick({
              dots: false,
              arrows: true,
              infinite: true,
              speed: 300,
              slidesToShow: 1,
              slidesToScroll: 1,
              mobileFirst: true,
              //accessibility: false,
              asNavFor: childClassName
            });
          
          return;
        },
      
        addSlickToChild: function ( parentClassName, childClassName, nextArrowClassName, prevArrowClassName) {

          $( childClassName ).slick({
            dots: false,
            prevArrow: prevArrowClassName,
            nextArrow: nextArrowClassName,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: parentClassName,
            focusOnSelect: true,
            accessibility: false,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              }
            ]
          });

          console.log(parentClassName)
          const slidePar = document.querySelector( parentClassName );
          const slideChild = document.querySelector( childClassName );
      
          if ( slidePar != null ) {
            let slides = slidePar.querySelectorAll('[data-slick-index]');
            for ( s of slides ) {
              s.setAttribute('aria-current' , false );
            }
          }
      
          if ( slideChild != null ) {
            let slides = slideChild.querySelectorAll('[data-slick-index]');
            for ( s of slides ) {
              s.setAttribute( 'aria-current' , false );
            }
          }
      
          $( parentClassName ).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if ( slidePar != null ) {
              let curr = slidePar.querySelector(`[data-slick-index="${currentSlide}"]`);
              let next = slidePar.querySelector(`[data-slick-index="${nextSlide}"]`);
              curr.setAttribute( 'aria-current' , false );
              next.setAttribute( 'aria-current' , true );
            }
          });
      
          $( parentClassName ).on('afterChange', function(event, slick, currentSlide, nextSlide) {
            if ( slideChild != null ) {
              let slides = slideChild.querySelectorAll(`[data-slick-index]`);
              for( let slide of slides ) {
                if ( slide.getAttribute('aria-hidden') == 'true' ) {
                  slide.style.visibility = "hidden";
                } else {
                  slide.style.visibility = "visible";
                }
              }
            }
          });
      
      
          $( childClassName ).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            if ( slideChild != null ) {
              let curr = slideChild.querySelector(`[data-slick-index="${currentSlide}"]`);
              let next = slideChild.querySelector(`[data-slick-index="${nextSlide}"]`);
              curr.setAttribute( 'aria-current' , false );
              next.setAttribute( 'aria-current' , true );
            }
          });
        }
    }

    SectionMethods.init()

    return SectionMethods
}